var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWashingMachine2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 336.2 368.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-15,.cls-24,.cls-39,.cls-42,.cls-43,.cls-50,.cls-63,.cls-7{fill:none;}.cls-2{fill:#9caab2;}.cls-3{fill:#ccd6e5;}.cls-4{fill:#b8bcc0;}.cls-5{fill:#343f42;}.cls-6,.cls-8{fill:#d0d6e0;}.cls-7,.cls-8{stroke:#343f42;}.cls-15,.cls-24,.cls-27,.cls-39,.cls-42,.cls-43,.cls-50,.cls-63,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-27,.cls-9{fill:#fff;}.cls-10{fill:#c8cad1;}.cls-11{fill:#d9e6ed;}.cls-12{fill:#acc6d1;}.cls-13{fill:#8ab3ff;}.cls-14{fill:#588df0;}.cls-15{stroke:#588df0;}.cls-16{fill:#303b3e;}.cls-17{fill:#f44d4d;}.cls-18{fill:#f66562;}.cls-19{fill:#d0d6e2;}.cls-20{fill:#303030;}.cls-21{fill:#c7c7c7;}.cls-22{fill:#9c9c9d;}.cls-23{fill:#bdbdbd;}.cls-24,.cls-27{stroke:#000;}.cls-24{stroke-width:0.37px;}.cls-25{fill:#008fff;}.cls-26{opacity:0.4;}.cls-27{stroke-width:1.39px;}.cls-28{fill:#cfcfcf;}.cls-29{fill:#9b9b9b;}.cls-30{fill:#c1c1c1;}.cls-31{fill:#84858b;}.cls-32{fill:url(#linear-gradient);}.cls-33{fill:url(#linear-gradient-2);}.cls-34{fill:#1f6aae;}.cls-35{fill:#257ac1;}.cls-36{fill:#1b5f9c;}.cls-37{fill:#124c77;}.cls-38{fill:url(#linear-gradient-3);}.cls-39{stroke:#84858b;}.cls-40{fill:#dadada;}.cls-41{clip-path:url(#clip-path);}.cls-42{stroke:#bdbdbd;stroke-width:2px;}.cls-43{stroke:#fff;}.cls-44{clip-path:url(#clip-path-2);}.cls-45{fill:#1c5f9c;}.cls-46{fill:#0e4a7c;}.cls-47{fill:#298cce;}.cls-48{fill:#267ac0;}.cls-49{fill:#2c3638;}.cls-50{stroke:#124c77;}.cls-51{clip-path:url(#clip-path-3);}.cls-52{fill:#960002;}.cls-53{fill:#ff031c;}.cls-54{fill:#b97109;}.cls-55{fill:#ff9c0e;}.cls-56{fill:#02782c;}.cls-57{fill:#00de42;}.cls-58{fill:#b4b4b4;}.cls-59{fill:#474949;}.cls-60{clip-path:url(#clip-path-4);}.cls-61{clip-path:url(#clip-path-5);}.cls-62{fill:#828282;}.cls-63{stroke:#303b3e;}.cls-64{fill:#cbd5e4;}.cls-65{fill:#b9bdc1;}.cls-66{fill:#1a3447;}.cls-67{fill:#6c8197;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 217.68,
    y1: 127.44,
    x2: 217.68,
    y2: 242.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#474949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30bdff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 99.65,
    y1: 85.58,
    x2: 99.65,
    y2: 240.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 66.4,
    y1: 188.83,
    x2: 123.4,
    y2: 188.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.25,9.14l-66.5,21.6c-10.23,3.18-10,9.25-10,18.25V59.42h0c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.46,6.92-.55a1.52,1.52,0,0,0,.84-1.21h0v0h0V45.74c0-3,0-6,6.65-8.16l59.85-19.44C132.9,16,132.9,19,132.9,25v7.67h0c.08.68.82,1.34,2.18,1.76,2.29.71,5.39.47,6.92-.54a1.58,1.58,0,0,0,.85-1.22h0v0h0V21.74C142.87,12.74,139.55,4.82,126.25,9.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.93,10.53c-.08-.68-.83-1.34-2.19-1.76-2.28-.71-5.38-.47-6.92.54A1.58,1.58,0,0,0,92,10.53h0v0h0v10h0c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.47,6.92-.54a1.58,1.58,0,0,0,.85-1.22h0v0h0v-10Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226,2.17c-.07-.68-.82-1.35-2.18-1.77-2.29-.7-5.39-.46-6.92.55a1.56,1.56,0,0,0-.85,1.22h0v0h0l0,74.66c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0V2.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.3,70.41,167.8,92c-10.23,3.18-10,9.24-10,18.24v10.44h0c.07.68.82,1.34,2.18,1.76,2.28.71,5.38.46,6.92-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0V107c0-3,0-6,6.65-8.16L234.3,79.41c6.65-2.16,6.65.84,6.65,6.84v7.67h0c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.46,6.92-.55a1.56,1.56,0,0,0,.85-1.21h0v0h0V83C250.92,74,247.6,66.08,234.3,70.41Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210,71.8c-.08-.68-.83-1.35-2.19-1.77-2.28-.7-5.38-.46-6.92.55A1.58,1.58,0,0,0,200,71.8h0v0h0V81.88h0c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.46,6.92-.54a1.59,1.59,0,0,0,.85-1.22h0v0h0v-10Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jar_01b",
    "data-name": "Jar_01b",
    viewBox: "0 0 9.26 18.96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M9.26,4.77h0c0-.65-.75-1.28-2-1.68a8.8,8.8,0,0,0-6.42.5A1.41,1.41,0,0,0,0,4.77H0V16.91H0c0,.65.75,1.28,2.05,1.68a8.8,8.8,0,0,0,6.42-.5,1.41,1.41,0,0,0,.79-1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8.33,1.64h0c0-.52-.59-1-1.63-1.34A7,7,0,0,0,1.56.7a1.08,1.08,0,0,0-.63.94h0v2h0c0,.51.59,1,1.63,1.34a7,7,0,0,0,5.14-.4,1.1,1.1,0,0,0,.63-.94h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 4.63,
    cy: 1.82,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(2.76 6.43) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M9.26,4.77a.24.24,0,0,0,0-.09,1.32,1.32,0,0,1-.76,1.26c-1.42.93-4.3,1.15-6.42.5C.74,6,0,5.41,0,4.76H0V16.91H0c0,.65.75,1.28,2.05,1.68a8.8,8.8,0,0,0,6.42-.5,1.41,1.41,0,0,0,.79-1.18h0V4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2.05,6.44c-1.3-.4-2-1-2-1.67H0V16.91H0c0,.65.75,1.28,2.05,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M8.31,1.56A1.37,1.37,0,0,1,7.43,3a7.21,7.21,0,0,1-5.21.19C1.15,2.8.9,2.1.94,1.55c0,0,0,.06,0,.09h0v2c0,.51.59,1,1.63,1.34a7,7,0,0,0,5.14-.4,1.1,1.1,0,0,0,.63-.94h0v-2h0S8.31,1.59,8.31,1.56Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jars_03",
    "data-name": "Jars_03",
    viewBox: "0 0 55.37 34.92"
  }, /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(0 15.96)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(15.37 11.08)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(30.74 4.88)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(46.11)",
    xlinkHref: "#Jar_01b"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Interface_02b",
    "data-name": "Interface_02b",
    viewBox: "0 0 33.25 48.54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.65 12.54 6.65 48.54 33.25 39.9 33.25 3.9 6.65 12.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "26.56 0 33.25 3.9 6.65 12.54 0 8.7 26.56 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0 8.7 6.65 12.54 6.65 48.54 0 44.7 0 8.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "23.27 10.14 23.27 25.14 29.93 22.98 29.93 7.98 23.27 10.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "23.27 28.14 23.27 40.14 29.93 37.98 29.93 25.98 23.27 28.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 9.97,
    y1: 17.46,
    x2: 19.85,
    y2: 14.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 9.97,
    y1: 20.46,
    x2: 19.85,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 9.97,
    y1: 23.46,
    x2: 19.85,
    y2: 20.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "9.97 29.46 19.95 26.22 19.95 41.22 9.97 44.46 9.97 29.46"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Screen_01b",
    "data-name": "Screen_01b",
    viewBox: "0 0 56.52 74.04"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "6.65 20.04 56.52 3.84 49.87 0 0 16.2 6.65 20.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0 70.2 0 16.2 6.65 20.04 6.65 74.04 0 70.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.52 3.84 6.65 20.04 6.65 74.04 56.52 57.84 56.52 3.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "53.27 11.01 9.97 24.96 9.97 60.96 53.2 46.92 53.27 11.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "49.87 15 13.3 26.88 13.3 56.88 49.87 45 49.87 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "16.63 28.8 16.63 52.8 29.93 48.48 29.93 24.48 16.63 28.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 46.55,
    y1: 22.08,
    x2: 33.25,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 46.55,
    y1: 28.08,
    x2: 33.25,
    y2: 32.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 46.55,
    y1: 34.08,
    x2: 33.25,
    y2: 38.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 46.55,
    y1: 40.08,
    x2: 33.25,
    y2: 44.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M48.32,57.73a2.8,2.8,0,0,0,1.67,0,4.17,4.17,0,0,0,2.77-3.86,3.33,3.33,0,0,0-2.25-3.23,2.8,2.8,0,0,0-1.67,0,4.17,4.17,0,0,0-2.77,3.86A3.3,3.3,0,0,0,48.32,57.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M47.24,54.86a3.3,3.3,0,0,1,2.18-3,1.71,1.71,0,0,1,1.49.16h0l0,0,3.18,2h0a1.68,1.68,0,0,1,.68,1.45,3.32,3.32,0,0,1-2.18,3,1.71,1.71,0,0,1-1.47-.16l-3.23-2.07A1.66,1.66,0,0,1,47.24,54.86Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 52.65,
    cy: 56.25,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-23.78 65.92) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M38.6,60.77a2.8,2.8,0,0,0,1.67,0A4.15,4.15,0,0,0,43,56.88a3.29,3.29,0,0,0-2.25-3.22,2.85,2.85,0,0,0-1.66,0,4.15,4.15,0,0,0-2.77,3.87A3.3,3.3,0,0,0,38.6,60.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M37.52,57.89a3.32,3.32,0,0,1,2.18-3,1.68,1.68,0,0,1,1.49.17h0l0,0,3.18,2h0a1.68,1.68,0,0,1,.68,1.44,3.3,3.3,0,0,1-2.18,3,1.71,1.71,0,0,1-1.47-.15l-3.24-2.07A1.7,1.7,0,0,1,37.52,57.89Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 42.93,
    cy: 59.28,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-30.27 59.3) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M30.5,63A2.55,2.55,0,0,0,32,63a4,4,0,0,0,2.62-3.64,2.89,2.89,0,0,0-2-2.83,2.55,2.55,0,0,0-1.52,0,4,4,0,0,0-2.62,3.64A2.88,2.88,0,0,0,30.5,63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 31.59,
    cy: 59.74,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-35.32 50.31) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M22.4,65.52a2.63,2.63,0,0,0,1.52,0,4,4,0,0,0,2.62-3.64,2.9,2.9,0,0,0-2-2.83,2.63,2.63,0,0,0-1.52,0,4,4,0,0,0-2.62,3.64A2.89,2.89,0,0,0,22.4,65.52Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 23.49,
    cy: 62.27,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-40.73 44.79) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M14.29,68a2.58,2.58,0,0,0,1.53,0,4,4,0,0,0,2.62-3.64,2.9,2.9,0,0,0-2-2.83,2.47,2.47,0,0,0-1.52,0,4,4,0,0,0-2.62,3.63A2.88,2.88,0,0,0,14.29,68Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 15.39,
    cy: 64.8,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-46.13 39.28) rotate(-54.11)"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Vask_Machine_02a_New_01",
    "data-name": "Vask_Machine_02a_New_01",
    viewBox: "0 0 336.2 368.65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vask_Machine_02a_New"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M286.33,244.83h0v6.78h0c.05.46.56.91,1.47,1.19a6.31,6.31,0,0,0,4.67-.37,1,1,0,0,0,.57-.82h0v-6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M286.33,171.71v74.56h0c.05.46.56.91,1.47,1.19a6.31,6.31,0,0,0,4.67-.37,1,1,0,0,0,.57-.82h0V171.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "308.32 154.42 241.83 176.02 241.83 191.02 308.32 169.42 308.32 154.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "316.25 158.99 249.75 180.6 249.75 195.6 316.25 173.99 316.25 158.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M249.75,183.41l56.52-18.36c2.5-.81,4.53.55,4.53,3a6.8,6.8,0,0,1-4.53,6l-56.52,18.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "239.78 174.84 249.75 180.6 316.25 158.99 306.27 153.23 239.78 174.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "239.78 174.84 241.83 176.02 241.83 191.02 239.78 189.84 239.78 174.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "247.7 179.41 249.75 180.6 249.75 195.6 247.7 194.41 247.7 179.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "239.78 174.84 241.83 176.02 241.83 185.02 239.78 183.84 239.78 174.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "247.7 179.41 249.75 180.6 249.75 189.6 247.7 188.41 247.7 179.41"
  }), /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    transform: "translate(252.25 140.04)",
    xlinkHref: "#Jars_03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "318.3 160.18 251.8 181.78 251.8 196.78 318.3 175.18 318.3 160.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "326.23 164.75 259.73 186.36 259.73 201.36 326.23 179.75 326.23 164.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M259.73,189.17l56.52-18.36c2.5-.81,4.52.55,4.52,3.05a6.79,6.79,0,0,1-4.52,6l-56.52,18.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "249.75 180.6 259.73 186.36 326.23 164.75 316.25 158.99 249.75 180.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "249.75 180.6 251.8 181.78 251.8 196.78 249.75 195.6 249.75 180.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "257.68 185.17 259.73 186.36 259.73 201.36 257.68 200.17 257.68 185.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "249.75 180.6 251.8 181.78 251.8 190.78 249.75 189.6 249.75 180.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "257.68 185.17 259.73 186.36 259.73 195.36 257.68 194.17 257.68 185.17"
  }), /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    transform: "translate(262.23 145.8)",
    xlinkHref: "#Jars_03"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("image", {
    width: 325,
    height: 192,
    transform: "translate(0 176.65)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M306.27,256.35h0v6.78h0c0,.46.56.91,1.47,1.19a6.31,6.31,0,0,0,4.67-.37,1,1,0,0,0,.57-.82h0v-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M306.27,183.23v74.56h0c0,.46.56.91,1.47,1.19a6.31,6.31,0,0,0,4.67-.37,1.05,1.05,0,0,0,.57-.82h0V183.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "328.27 165.93 261.78 187.54 261.78 202.54 328.27 180.93 328.27 165.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "336.2 170.51 269.7 192.12 269.7 207.12 336.2 185.51 336.2 170.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M269.7,194.93l56.52-18.36c2.5-.81,4.53.55,4.53,3.05a6.8,6.8,0,0,1-4.53,6L269.7,204"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "259.73 186.36 269.7 192.12 336.2 170.51 326.23 164.75 259.73 186.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "259.73 186.36 261.78 187.54 261.78 202.54 259.73 201.36 259.73 186.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "267.65 190.93 269.7 192.12 269.7 207.12 267.65 205.93 267.65 190.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "259.73 186.36 261.78 187.54 261.78 196.54 259.73 195.36 259.73 186.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "267.65 190.93 269.7 192.12 269.7 201.12 267.65 199.93 267.65 190.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M247.79,272.35h0v14h0c.1.94,1.14,1.86,3,2.45,3.17,1,7.48.64,9.61-.76a2.17,2.17,0,0,0,1.17-1.69h0v0h0v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M150.14,295.25h0v14h0c.11.94,1.15,1.87,3,2.45,3.17,1,7.48.64,9.61-.76a2.16,2.16,0,0,0,1.17-1.69h0v0h0v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M90.29,260.7h0v14h0c.11.94,1.15,1.86,3,2.44,3.17,1,7.48.65,9.61-.76a2.15,2.15,0,0,0,1.17-1.68h0v0h0v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M47.07,235.74h0v14h0c.1.95,1.15,1.87,3,2.45,3.18,1,7.48.64,9.62-.76a2.18,2.18,0,0,0,1.17-1.69h0v0h0v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M166.15,132.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "169.95 131.53 169.95 311.53 269.7 279.12 269.7 99.12 169.95 131.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "36.95 57.74 163.3 130.69 163.3 310.69 36.95 237.74 36.95 57.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "163.3 130.69 169.95 131.53 169.95 311.53 163.3 310.69 163.3 130.69 163.3 130.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "36.95 57.74 163.3 130.69 169.95 131.53 269.7 99.12 140.03 24.25 36.95 57.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "172.8 148.45 172.8 250.45 262.57 221.28 262.57 119.28 172.8 148.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "102.97 114.13 159.86 146.97 159.86 248.97 102.97 216.13 102.97 114.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "39.8 77.66 66.4 93.02 66.4 195.02 39.8 179.66 39.8 77.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "66.4 93.02 102.61 113.93 102.97 171.13 66.4 150.02 66.4 93.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M212.7,141.48v90l-33.25,10.81v-90Zm10-3.24v90l33.25-10.8v-90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M156.17,150.85v90.06l-23.27-13.5v-90Zm-113-65.27v90l20,11.58V97.1Zm63.18,36.47v44.52l16.62,9.6V131.59ZM69.72,100.94v45l26.6,15.35v-45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "176.6 309.37 176.6 255.37 203.1 270.7 203.1 324.7 176.6 309.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "176.6 255.37 263.05 227.28 289.55 242.62 203.1 270.7 176.6 255.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "203.1 324.7 289.45 296.6 289.55 242.62 203.2 270.72 203.1 324.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "183.25 265.2 183.25 268.2 196.45 275.86 196.45 272.86 183.25 265.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "183.25 271.2 183.25 274.2 196.45 281.86 196.45 278.86 183.25 271.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "183.25 277.2 183.25 280.2 196.45 287.86 196.45 284.86 183.25 277.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "183.25 283.2 183.25 286.2 196.45 293.86 196.45 290.86 183.25 283.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "183.25 289.2 183.25 292.2 196.45 299.86 196.45 296.86 183.25 289.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "183.25 295.2 183.25 298.2 196.45 305.86 196.45 302.86 183.25 295.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "183.25 301.2 183.25 304.2 196.45 311.86 196.45 308.86 183.25 301.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "123.4 182.65 123.4 227.65 66.88 195.02 66.4 150.02 123.4 182.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "133.38 257.41 146.68 265.09 146.68 268.09 133.38 260.41 133.38 257.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "93.48 234.37 106.78 242.05 106.78 245.05 93.48 237.37 93.48 234.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "53.29 211.17 66.59 218.85 66.59 221.85 53.29 214.17 53.29 211.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "156.65 264.85 156.65 303.85 123.4 284.65 123.4 245.65 156.65 264.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "116.75 241.81 116.75 280.81 83.5 261.62 83.5 222.62 116.75 241.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "76.85 218.78 76.37 257.48 43.6 238.58 43.6 199.58 76.85 218.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M126.25,9.14l-66.5,21.6c-10.23,3.18-10,9.25-10,18.25V59.42h0c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.46,6.92-.55a1.52,1.52,0,0,0,.84-1.21h0v0h0V45.74c0-3,0-6,6.65-8.16l59.85-19.44C132.9,16,132.9,19,132.9,25v7.67h0c.08.68.82,1.34,2.18,1.76,2.29.71,5.39.47,6.92-.54a1.58,1.58,0,0,0,.85-1.22h0v0h0V21.74C142.87,12.74,139.55,4.82,126.25,9.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M135.94,35.55v-14c0-6-1.16-8.62-7.81-6.46L100.22,24.2,65.08,35.61c-10.23,3.18-8.21,8.67-8.21,17.67V63.71h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M141.29,34.69V23.8c0-9-1-17.66-14.35-13.34L62.61,31.36c-10.23,3.18-10,9.24-10,18.24V64.1l0-4.06"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M101.93,10.53c-.08-.68-.83-1.34-2.19-1.76-2.28-.71-5.38-.47-6.92.54A1.58,1.58,0,0,0,92,10.53h0v0h0v10h0c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.47,6.92-.54a1.58,1.58,0,0,0,.85-1.22h0v0h0v-10Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 93.62,
    y1: 10.85,
    x2: 93.62,
    y2: 23.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-42",
    x1: 99.25,
    y1: 10.85,
    x2: 99.25,
    y2: 23.54
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.96,
    cy: 10.85,
    rx: 2.01,
    ry: 4.55,
    transform: "translate(85.07 107.69) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "136.7 97.33 136.7 106.33 213.18 81.48 213.18 72.48 136.7 97.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "73.25 60.61 73.25 69.61 136.7 106.33 136.96 97.39 73.25 60.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "126.73 37.57 100.48 22.25 159.98 2.77 186.58 18.13 126.73 37.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "100.48 22.25 126.98 37.63 136.96 97.39 73.25 60.61 100.48 22.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "126.73 37.57 136.7 97.33 213.18 72.48 186.58 18.13 126.73 37.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M42.83,279.11h0v6.79h0c0,.46.56.9,1.48,1.19a6.33,6.33,0,0,0,4.66-.37,1.05,1.05,0,0,0,.57-.82h0v0h0v-6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M42.83,206v74.55h0c0,.46.56.91,1.48,1.19a6.29,6.29,0,0,0,4.66-.37,1,1,0,0,0,.57-.82h0V206Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "95.53 178.56 29.03 200.16 29.03 215.16 95.53 193.56 95.53 178.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "103.45 183.13 36.95 204.74 36.95 219.74 103.45 198.13 103.45 183.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M103.45,195.18,46.93,213.54c-2.5.82-4.52-.55-4.52-3a6.79,6.79,0,0,1,4.52-6l56.52-18.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "26.98 198.98 36.95 204.74 116.75 178.81 106.78 173.05 26.98 198.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "26.98 198.98 29.03 200.16 29.03 215.16 26.98 213.98 26.98 198.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "34.9 203.56 36.95 204.74 36.95 219.74 34.9 218.56 34.9 203.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "26.98 198.98 29.03 200.16 29.03 209.16 26.98 207.98 26.98 198.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "34.9 203.56 36.95 204.74 36.95 213.74 34.9 212.56 34.9 203.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 47.79,
    cy: 208.92,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-142.31 109.96) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 57.77,
    cy: 205.68,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-136.33 116.42) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 67.74,
    cy: 202.44,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-130.35 122.87) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 77.72,
    cy: 199.2,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-124.37 129.33) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 87.69,
    cy: 195.96,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-118.39 135.79) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 97.67,
    cy: 192.72,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-112.41 142.24) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 274.6,
    cy: 197.21,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-53.54 278.59) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 284.57,
    cy: 193.97,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-47.56 285.05) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 294.55,
    cy: 190.73,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-41.58 291.5) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 304.52,
    cy: 187.49,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-35.6 297.96) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 314.5,
    cy: 184.25,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-29.62 304.42) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 324.47,
    cy: 181.01,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-23.64 310.87) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: 135,
    y1: 85.88,
    x2: 208.1,
    y2: 62.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: 77.6,
    y1: 53.38,
    x2: 134.32,
    y2: 85.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M226,2.17c-.07-.68-.82-1.35-2.18-1.77-2.29-.7-5.39-.46-6.92.55a1.56,1.56,0,0,0-.85,1.22h0v0h0l0,74.66c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0V2.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 217.71,
    y1: 2.49,
    x2: 217.71,
    y2: 79.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-42",
    x1: 223.33,
    y1: 2.49,
    x2: 223.33,
    y2: 79.77
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 221.05,
    cy: 2.22,
    rx: 2.2,
    ry: 4.99,
    transform: "translate(216.44 223.22) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M226,4.22a1.48,1.48,0,0,1-.82,1.32c-1.54,1-4.64,1.24-6.92.54-1.43-.44-2.2-1.12-2.21-1.83l0,9.25c.08.67.83,1.34,2.19,1.76,2.28.7,5.38.46,6.92-.55A1.57,1.57,0,0,0,226,13.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 219.44,
    y: 7.97,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M226,13.39a1.49,1.49,0,0,1-.83,1.32c-1.54,1-4.64,1.24-6.92.54-1.43-.44-2.2-1.12-2.21-1.83l0,9.25c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55a1.57,1.57,0,0,0,.84-1.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 219.44,
    y: 17.15,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M226,22.57a1.48,1.48,0,0,1-.83,1.31c-1.54,1-4.64,1.24-6.92.54-1.43-.43-2.2-1.12-2.21-1.83l0,9.25c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.54a1.58,1.58,0,0,0,.84-1.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 219.44,
    y: 26.21,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "163.3 43.69 169.95 65.53 196.55 56.88 189.9 35.05 163.3 43.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "166.63 45.61 171.59 61.99 193.23 54.96 188.2 38.6 166.63 45.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M175.2,51.4a2.72,2.72,0,0,1-3.92.22,4.52,4.52,0,0,1-1.09-5,3.51,3.51,0,0,1,.57-.91,2.71,2.71,0,0,1,3.92-.22,4.51,4.51,0,0,1,1.09,5A3.4,3.4,0,0,1,175.2,51.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M176,44.78,172.47,46a1.76,1.76,0,0,0-1.17,1.1,3.34,3.34,0,0,0,.76,3.62,1.61,1.61,0,0,0,1.3.42l3.93-1.32a1.83,1.83,0,0,0,1-1,3.36,3.36,0,0,0-.76-3.63A1.57,1.57,0,0,0,176,44.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 176.61,
    cy: 47.3,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-5.09 26.99) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M183.71,48.35a2.39,2.39,0,0,1-3.5.19,4.27,4.27,0,0,1-1-4.65,3.22,3.22,0,0,1,.52-.84,2.41,2.41,0,0,1,3.5-.19,4.29,4.29,0,0,1,1,4.66A3.33,3.33,0,0,1,183.71,48.35Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 181.71,
    cy: 45.7,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-4.8 27.73) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M185.71,55.71a2.42,2.42,0,0,1-3.51.19,4.27,4.27,0,0,1-1-4.66,3.3,3.3,0,0,1,.51-.83,2.4,2.4,0,0,1,3.51-.19,4.25,4.25,0,0,1,1,4.65A3.19,3.19,0,0,1,185.71,55.71Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 183.71,
    cy: 53.06,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-5.87 28.11) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M177.34,58.74a2.4,2.4,0,0,1-3.5.18,4.25,4.25,0,0,1-1-4.65,3,3,0,0,1,.52-.83,2.39,2.39,0,0,1,3.5-.19,4.27,4.27,0,0,1,1,4.65A3.22,3.22,0,0,1,177.34,58.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 175.34,
    cy: 56.09,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-6.42 26.89) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "185.01 42.48 188.33 53.4 190.45 52.71 187.13 41.8 185.01 42.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "133.38 53.41 140.03 75.25 166.63 66.61 159.98 44.77 133.38 53.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "136.7 55.33 141.67 71.72 163.3 64.69 158.28 48.32 136.7 55.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M145.28,61.12a2.73,2.73,0,0,1-3.93.22,4.52,4.52,0,0,1-1.08-5,3.23,3.23,0,0,1,.56-.91,2.73,2.73,0,0,1,3.93-.22,4.52,4.52,0,0,1,1.08,5A3.23,3.23,0,0,1,145.28,61.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M146,54.51l-3.49,1.2a1.77,1.77,0,0,0-1.18,1.1,3.36,3.36,0,0,0,.77,3.62,1.6,1.6,0,0,0,1.29.43l3.94-1.33a1.86,1.86,0,0,0,1-1,3.36,3.36,0,0,0-.77-3.62A1.52,1.52,0,0,0,146,54.51Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 146.69,
    cy: 57.02,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-6.89 22.61) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M153.79,58.08a2.41,2.41,0,0,1-3.51.18,4.25,4.25,0,0,1-1-4.65,3,3,0,0,1,.51-.83,2.4,2.4,0,0,1,3.51-.19,4.25,4.25,0,0,1,1,4.65A3.19,3.19,0,0,1,153.79,58.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 151.79,
    cy: 55.43,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-6.59 23.36) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M155.78,65.43a2.39,2.39,0,0,1-3.5.19,4.27,4.27,0,0,1-1-4.65,3.22,3.22,0,0,1,.52-.84,2.39,2.39,0,0,1,3.5-.19,4.29,4.29,0,0,1,1,4.66A3.33,3.33,0,0,1,155.78,65.43Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 153.79,
    cy: 62.78,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-7.67 23.74) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M147.42,68.46a2.41,2.41,0,0,1-3.51.19,4.26,4.26,0,0,1-1-4.66,3,3,0,0,1,.51-.83,2.4,2.4,0,0,1,3.51-.19,4.25,4.25,0,0,1,1,4.65A3.19,3.19,0,0,1,147.42,68.46Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 145.42,
    cy: 65.81,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-8.22 22.52) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "155.08 52.21 158.41 63.13 160.53 62.44 157.2 51.52 155.08 52.21"
  }), /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    transform: "translate(36.99 165.08)",
    xlinkHref: "#Jars_03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "105.5 184.32 39.01 205.92 39.01 220.92 105.5 199.32 105.5 184.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "113.43 188.89 46.93 210.5 46.93 225.5 113.43 203.89 113.43 188.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M113.43,200.94,56.9,219.3c-2.49.82-4.52-.55-4.52-3.05a6.81,6.81,0,0,1,4.52-6l56.53-18.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "36.95 204.74 46.93 210.5 123.4 185.65 123.4 182.65 116.75 178.81 36.95 204.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "36.95 204.74 39.01 205.92 39.01 220.92 36.95 219.74 36.95 204.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "44.88 209.31 46.93 210.5 46.93 225.5 44.88 224.31 44.88 209.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "36.95 204.74 39.01 205.92 39.01 214.92 36.95 213.74 36.95 204.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "44.88 209.31 46.93 210.5 46.93 219.5 44.88 218.31 44.88 209.31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 57.77,
    cy: 214.68,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-143.18 119.58) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 67.74,
    cy: 211.44,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-137.2 126.04) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 77.72,
    cy: 208.2,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-131.22 132.5) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 87.69,
    cy: 204.96,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-125.24 138.95) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 97.67,
    cy: 201.72,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-119.26 145.41) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 107.64,
    cy: 198.48,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-113.28 151.87) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    transform: "translate(46.96 170.84)",
    xlinkHref: "#Jars_03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M62.78,290.63h0v6.78h0c.05.46.56.91,1.48,1.19a6.29,6.29,0,0,0,4.66-.37,1,1,0,0,0,.57-.82h0v-6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M62.78,217.51v74.56h0c.05.46.56.91,1.48,1.19a6.29,6.29,0,0,0,4.66-.37,1,1,0,0,0,.57-.82h0V217.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "115.48 190.08 48.98 211.68 48.98 226.68 115.48 205.08 115.48 190.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "123.4 194.65 56.9 216.26 56.9 231.26 123.4 209.65 123.4 194.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M123.4,206.7,66.88,225.06c-2.5.81-4.52-.55-4.52-3.05a6.79,6.79,0,0,1,4.52-6l56.52-18.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "46.93 210.5 56.9 216.26 123.4 194.65 123.4 185.65 46.93 210.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "46.93 210.5 48.98 211.68 48.98 226.68 46.93 225.5 46.93 210.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "54.85 215.07 56.9 216.26 56.9 231.26 54.85 230.07 54.85 215.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "46.93 210.5 48.98 211.68 48.98 220.68 46.93 219.5 46.93 210.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "54.85 215.07 56.9 216.26 56.9 225.26 54.85 224.07 54.85 215.07"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 67.74,
    cy: 220.44,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-144.06 129.21) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 77.72,
    cy: 217.2,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-138.08 135.67) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 87.69,
    cy: 213.96,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-132.1 142.12) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 97.67,
    cy: 210.72,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-126.12 148.58) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 107.64,
    cy: 207.48,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-120.14 155.04) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 117.62,
    cy: 204.23,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-114.16 161.49) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    transform: "translate(56.93 176.6)",
    xlinkHref: "#Jars_03"
  }), /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    transform: "translate(272.2 151.56)",
    xlinkHref: "#Jars_03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M234.3,70.41,167.8,92c-10.23,3.18-10,9.24-10,18.24v10.44h0c.07.68.82,1.34,2.18,1.76,2.28.71,5.38.46,6.92-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0V107c0-3,0-6,6.65-8.16L234.3,79.41c6.65-2.16,6.65.84,6.65,6.84v7.67h0c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.46,6.92-.55a1.56,1.56,0,0,0,.85-1.21h0v0h0V83C250.92,74,247.6,66.08,234.3,70.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M244,96.82v-14c0-6-1.17-8.63-7.82-6.46l-27.91,9.06L173.13,96.88c-10.23,3.18-8.21,8.67-8.21,17.67V125h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M249.34,96V85.07c0-9-1.05-17.66-14.35-13.34l-64.33,20.9c-10.23,3.18-10,9.24-10,18.24v14.5l0-4.06"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M210,71.8c-.08-.68-.83-1.35-2.19-1.77-2.28-.7-5.38-.46-6.92.55A1.58,1.58,0,0,0,200,71.8h0v0h0V81.88h0c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.46,6.92-.54a1.59,1.59,0,0,0,.85-1.22h0v0h0v-10Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 201.67,
    y1: 72.12,
    x2: 201.67,
    y2: 84.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-42",
    x1: 207.3,
    y1: 72.12,
    x2: 207.3,
    y2: 84.81
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.01,
    cy: 72.12,
    rx: 2.01,
    ry: 4.55,
    transform: "translate(130.68 276.34) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("use", {
    width: 33.25,
    height: 48.54,
    transform: "translate(206.53 263.94)",
    xlinkHref: "#Interface_02b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Interface_01b"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "243 260.74 286.32 246.72 286.32 291.71 243 305.74 243 260.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "274.84 262.44 274.84 292.44 284.81 289.19 284.81 259.19 274.84 262.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M249.15,267.93a2.72,2.72,0,0,1-2.74-2.83,4.51,4.51,0,0,1,3.05-4.09,3.38,3.38,0,0,1,1.07-.18,2.73,2.73,0,0,1,2.74,2.83,4.52,4.52,0,0,1-3.06,4.09A3.37,3.37,0,0,1,249.15,267.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M254.64,264.16l-3.2-1.85a1.78,1.78,0,0,0-1.6-.16,3.34,3.34,0,0,0-2.23,3,1.62,1.62,0,0,0,.52,1.26l3.59,2.1a1.81,1.81,0,0,0,1.44.07,3.36,3.36,0,0,0,2.23-3A1.54,1.54,0,0,0,254.64,264.16Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 253.16,
    cy: 266.3,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-113.71 286.59) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M259.12,264.68a2.72,2.72,0,0,1-2.74-2.82,4.51,4.51,0,0,1,3.06-4.09,3.32,3.32,0,0,1,1.06-.18,2.73,2.73,0,0,1,2.74,2.82,4.51,4.51,0,0,1-3.06,4.1A3.31,3.31,0,0,1,259.12,264.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M264.62,260.92l-3.21-1.85a1.74,1.74,0,0,0-1.6-.16,3.35,3.35,0,0,0-2.23,2.95,1.59,1.59,0,0,0,.53,1.26l3.58,2.1a1.83,1.83,0,0,0,1.45.07,3.36,3.36,0,0,0,2.23-3A1.56,1.56,0,0,0,264.62,260.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 263.14,
    cy: 263.06,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-107.73 293.04) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M267.19,261.76a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3.34,3.34,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,267.19,261.76Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 267.88,
    cy: 258.52,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-102.6 295.06) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M273.84,259.6a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,273.84,259.6Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 274.53,
    cy: 256.36,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-98.61 299.36) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M280.49,257.44a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,280.49,257.44Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 281.18,
    cy: 254.2,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-94.63 303.67) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M279.29,269.87a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,279.29,269.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 279.98,
    cy: 266.63,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-104.52 307.13) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M279.29,278.87a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,279.29,278.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 279.98,
    cy: 275.63,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-111.37 310.3) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M279.29,287.87a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,279.29,287.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 279.98,
    cy: 284.63,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-118.23 313.47) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: 276.47,
    y1: 272.46,
    x2: 283.12,
    y2: 270.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: 276.47,
    y1: 281.3,
    x2: 283.12,
    y2: 279.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: 276.47,
    y1: 290.42,
    x2: 283.12,
    y2: 288.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "265.71 265.61 265.71 280.61 272.36 278.45 272.36 263.45 265.71 265.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "265.71 283.61 265.71 295.61 272.36 293.45 272.36 281.45 265.71 283.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "246.42 272.04 246.42 287.04 253.07 284.88 253.07 269.88 246.42 272.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "246.42 290.04 246.42 302.04 253.07 299.88 253.07 287.88 246.42 290.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 256.76,
    y1: 271.32,
    x2: 263.05,
    y2: 269.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 256.4,
    y1: 274.44,
    x2: 263.05,
    y2: 272.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 256.4,
    y1: 277.44,
    x2: 263.05,
    y2: 275.28
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "256.4 283.44 263.05 281.28 263.05 296.28 256.4 298.44 256.4 283.44"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "189.12 122.66 209.07 116.17 189.12 104.66 169.17 111.14 189.12 122.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "229.02 100.69 229.02 142.69 222.37 144.85 222.37 102.85 229.02 100.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "215.72 105.01 215.72 147.01 222.37 144.85 222.37 102.85 215.72 105.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "222.37 90.85 202.42 79.33 195.77 81.5 215.72 93.01 222.37 90.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "212.4 100.09 189.12 86.66 195.77 81.5 215.72 93.01 212.4 100.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "195.77 90.5 195.77 114.5 189.12 116.66 189.12 86.66 195.77 90.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "182.47 82.82 182.47 112.82 189.12 116.66 189.12 86.66 182.47 82.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "215.72 93.01 222.37 102.85 215.72 105.01 212.4 100.09 215.72 93.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "222.37 90.85 229.02 100.69 222.37 102.85 215.72 93.01 222.37 90.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "195.77 81.5 189.12 86.66 182.47 82.82 189.12 77.66 195.77 81.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "202.42 79.33 195.77 81.5 189.12 77.66 195.77 75.5 202.42 79.33"
  }), /*#__PURE__*/React.createElement("use", {
    width: 56.52,
    height: 74.04,
    transform: "translate(195.77 137.29)",
    xlinkHref: "#Screen_01b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vask_Sterilisation_-_Handlinger",
    "data-name": "Vask & Sterilisation - Handlinger"
  }, /*#__PURE__*/React.createElement("use", {
    width: 336.2,
    height: 368.65,
    xlinkHref: "#Vask_Machine_02a_New_01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingMachine2B);
export default __webpack_public_path__ + "static/media/washing-machine-2-b.50d2b51646abb3d2fec5e960f0d0915c.svg";
export { ForwardRef as ReactComponent };